import { render, staticRenderFns } from "./VSlider.vue?vue&type=template&id=64633140&"
import script from "./VSlider.vue?vue&type=script&lang=js&"
export * from "./VSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64633140')) {
      api.createRecord('64633140', component.options)
    } else {
      api.reload('64633140', component.options)
    }
    module.hot.accept("./VSlider.vue?vue&type=template&id=64633140&", function () {
      api.rerender('64633140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VSlider/VSlider.vue"
export default component.exports